import { createStore } from 'redux'

const initialState = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  asideShow: false,
  darkMode: false,
  payors: [],
  facilities: [],
  facilitiesOption: [],
  refreshReferral: false,
  users: [],
  refreshWorkflow: false,
  usersOption: [],
  lookups: {},
  locations: [],
  manualTriggers: []
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
